module.exports = __webpack_public_path__ + "static/media/8_file_import_requirements_and_best_practices.ce081c0f.png";